export default "__VITE_ASSET__CFuqLqgg__"